/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Education_UndergradInputs */

const en_onboarding_education_undergrad = /** @type {(inputs: Onboarding_Education_UndergradInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currently in undergrad (college)`)
};

const es_onboarding_education_undergrad = /** @type {(inputs: Onboarding_Education_UndergradInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualmente en universidad (pregrado)`)
};

/**
* | output |
* | --- |
* | "Currently in undergrad (college)" |
*
* @param {Onboarding_Education_UndergradInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_education_undergrad = /** @type {((inputs?: Onboarding_Education_UndergradInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Education_UndergradInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_education_undergrad(inputs)
	return en_onboarding_education_undergrad(inputs)
});